import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DialogHelperService } from 'app/shared/dialogs/services/dialog-helper.service';
import { TranslateService } from '@ngx-translate/core';
import { setPortalMode } from 'app/store/ui';
import { SysExternalWebUserType } from 'app/shared/enums/sys-application.enum';
import { Identifier } from '../models/storage.model';
import { AuthService } from './auth.service';
import { LoginPayload } from '../models/login-payload.model';

@Injectable({
  providedIn: 'root',
})
export class PortalSelectionService {
  constructor(
    private dialogHelperService: DialogHelperService,
    private translateService: TranslateService,
    private store: Store,
    private router: Router,
    private authService: AuthService
  ) {}

  handlePortalSelection(nonce: string, username: string): Observable<void> {
    return this.showPortalSelectionDialog().pipe(
      switchMap(selectedType => {
        const loginPayload: LoginPayload = {
          username,
          nonce,
          sysExternalWebUserTypeId: selectedType,
        };

        return this.authService.loginUser(loginPayload).pipe(
          map(res => {
            if (res) {
              this.completeLogin(res);
            }
          })
        );
      })
    );
  }

  private showPortalSelectionDialog(): Observable<number> {
    return this.dialogHelperService
      .confirmDialog(
        this.translateService.instant('confirmMessages.asfOrClient'),
        this.translateService.instant('general.client'),
        this.translateService.instant('general.asf')
      )
      .pipe(
        map(result =>
          result ? SysExternalWebUserType.SSICSClientPortal : SysExternalWebUserType.SSICSASFPortal
        )
      );
  }

  completeLogin(res: any, isReadOnly: boolean = false): void {
    if (res.sysExternalWebUserTypeId) {
      this.store.dispatch(setPortalMode({ portalMode: res.sysExternalWebUserTypeId }));
    }
    localStorage.setItem(Identifier.TYPE_READ_ONLY, isReadOnly.toString());

    if (res.sysExternalWebUserTypeId === SysExternalWebUserType.SSICSClientPortal) {
      this.router.navigate(['/mycontracts']);
    } else if (res.sysExternalWebUserTypeId === SysExternalWebUserType.SSICSASFPortal) {
      this.router.navigate(['/search']);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
